var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('loader'),_vm._v(" "),_c('pwa-update'),_vm._v(" "),_c('notifications'),_vm._v(" "),_c('side-menu'),_vm._v(" "),_c('div',{staticClass:"main-content"},[_c('page-content')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }